import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'dialog-header',
  imports: [MatDialogModule, MatIconModule, NgClass],
  templateUrl: './dialog-header.component.html',
  styleUrl: './dialog-header.component.scss',
})
export class DialogHeaderComponent {
  @Input() titleId: string = 'dialog-title';
  @Input() centered = false;
}
